// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TeamModal_modal-content__MMfkZ h1{text-transform:capitalize}.TeamModal_modal-content__MMfkZ h1.TeamModal_creating__uHVoq{text-transform:none}.TeamModal_modal-content__MMfkZ button{margin-top:3rem}", "",{"version":3,"sources":["webpack://./src/modals/TeamModal.scss"],"names":[],"mappings":"AACE,mCACE,yBAAA,CACA,6DACE,mBAAA,CAIJ,uCACE,eAAA","sourcesContent":[".modal-content {\n  h1 {\n    text-transform: capitalize;\n    &.creating {\n      text-transform: none;\n    }\n  }\n\n  button {\n    margin-top: 3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": "TeamModal_modal-content__MMfkZ",
	"creating": "TeamModal_creating__uHVoq"
};
export default ___CSS_LOADER_EXPORT___;
